import React from 'react';
import * as styles from './CriteriaDescription.module.scss';
import { List, ListItem, Text } from 'components/core';

export type CriteriaDescriptionProps = {
  renderAsList: boolean;
  description: string[];
};

const CriteriaDescription = ({
  description,
  renderAsList,
}: CriteriaDescriptionProps) => {
  if (!description.length) {
    return <Text className={styles.na}>N/A</Text>;
  }

  if (renderAsList) {
    return (
      <List>
        {description.map((item, index) => (
          <ListItem key={index}>
            <p
              className={styles.criteriaItemText}
              dangerouslySetInnerHTML={{ __html: item }}
            ></p>
          </ListItem>
        ))}
      </List>
    );
  }

  // A multi-item description only occurs on rows corrupted by the old conflict
  // merge; join so nothing is hidden (the host's pre-wrap renders the newlines).
  return (
    <p
      className={styles.criteriaItemText}
      dangerouslySetInnerHTML={{ __html: description.join('\n') }}
    ></p>
  );
};

export default CriteriaDescription;
